export function pickSection(wanted: string | null | undefined, available: readonly string[], fallback: string): string {
  if (wanted && available.includes(wanted)) return wanted;
  return available.includes(fallback) ? fallback : (available[0] ?? fallback);
}

export function withSection(current: URLSearchParams, id: string, home: string): URLSearchParams {
  const next = new URLSearchParams(current);
  next.delete('tab');
  if (id === home) next.delete('section');
  else next.set('section', id);
  return next;
}
